var global = require('../internals/global');
var shared = require('../internals/shared');
var uid = require('../internals/uid');
var NATIVE_SYMBOL = require('../internals/native-symbol');

var Symbol = global.Symbol;
var store = shared('wks');

module.exports = function (name) {
  return store[name] || (store[name] = NATIVE_SYMBOL && Symbol[name]
    || (NATIVE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};



//////////////////
// WEBPACK FOOTER
// /Users/digitalcover/Documents/projects/digitalsecurite/wp-content/themes/digitalcover/node_modules/core-js/internals/well-known-symbol.js
// module id = 3
// module chunks = 0